module.exports = __webpack_public_path__ + "img/resp-portfolio.53a66690.svg";